import { render, staticRenderFns } from "./FamousSaying.vue?vue&type=template&id=3fc627fa&scoped=true&"
import script from "./FamousSaying.vue?vue&type=script&lang=js&"
export * from "./FamousSaying.vue?vue&type=script&lang=js&"
import style0 from "./FamousSaying.vue?vue&type=style&index=0&id=3fc627fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc627fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
